import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import App from './App';

// GA4 — initialize una sola vez al arranque. El tracking de page views por
// cambio de ruta vive en <RouteTracker/> dentro del Router (App.jsx) para
// poder usar useLocation. NO usamos gtag manual en index.html porque no
// rastrea bien los cambios de ruta en SPA.
ReactGA.initialize('G-7JME4V8D92');

// FASE 1.A: estilos del mockup v4 (mobile-first + override desktop ≥768px)
import './styles/mockup-mobile.css';
import './styles/mockup-desktop.css';
// FASE 4 UX — index.css importado a nivel global (antes solo lo importaban
// los Dashboards). Garantiza que las vars [data-theme="dark"] estén
// disponibles desde el primer paint en cualquier ruta y que su orden en el
// bundle sea POSTERIOR a los mockup CSS (que también declaran :root con
// vars light), de forma que sus reglas ganen por orden de aparición.
import './index.css';
// Overrides dark para componentes que usan paletas LIGHT hardcodeadas
// (.mc / MotorInfoCard, .greeting de LivePage, .dm-* del UserDropdown, etc.).
// Sin este import, esos componentes quedaban en blanco cuando data-theme="dark".
// Va DESPUÉS de index.css para ganar por orden de aparición.
import './styles/dashboard-dark.css';
// Mockup oficial Edge Elite (1831 líneas, 64KB) — importado al FINAL para
// que sus reglas pisen las equivalentes de index.css cuando hay solapamiento
// (.kpi, .panel, .matches, .topbar, .sidebar, etc.).

// MVP pre-launch: solo light theme. Sin setter de data-theme en <html>
// para asegurar que cualquier regla [data-theme="dark"] residual del
// CSS quede inerte (sin attribute, no matchea). Las vars de :root son
// las únicas que aplican.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// PWA: registro del service worker (shell cache network-first; nunca cachea
// RTDB/Firestore/Functions — ver public/sw.js). Solo en producción para no
// interferir con el dev server de CRA.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      console.warn('[sw] registro falló:', e);
    });
  });
}
